import { createContext, useContext, useState } from 'react';
import { ConfirmDialog } from 'components/common/ConfirmDialog';

export const ConfirmDialogContext = createContext(null);

export const useConfirmDialog = () => {
  const context = useContext(ConfirmDialogContext);
  if (!context) {
    throw new Error('useConfirmDialog must be used within ConfirmDialogProvider');
  }
  return context;
};

export const ConfirmDialogProvider = ({ children, ...props }) => {
  const [dialog, setDialog] = useState({
    show: false,
    title: '',
    text: '',
    handler: null,
    cancelButtonText: 'Cancel',
    confirmButtonText: 'Delete',
  });

  const closeConfirmDialog = () => {
    setDialog({
      show: false,
      title: '',
      text: '',
      handler: null,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Delete',
    });
  };

  const openConfirmDialog = (dialogData = {}) => {
    setDialog({
      ...dialog,
      show: true,
      ...dialogData,
    });
  };

  return (
    <ConfirmDialogContext.Provider
      value={{ dialog, closeConfirmDialog, openConfirmDialog }}
      {...props}
    >
      {children}
      <ConfirmDialog
        show={dialog.show}
        title={dialog.title}
        text={dialog.text}
        handler={dialog.handler}
        cancelButtonText={dialog.cancelButtonText}
        confirmButtonText={dialog.confirmButtonText}
        closeDialog={closeConfirmDialog}
      />
    </ConfirmDialogContext.Provider>
  );
};
